import {styled, Theme} from "@core-ui/react-stitch";
import {ColorSwatchProps} from "../types";
import {outline} from "./swatch-outlines";

export const SMALL_COLOR_SWATCH_WIDTH = "1.125rem";
export const SMALL_COLOR_SWATCH_PADDING = "0.4375rem";
export const DEFAULT_COLOR_SWATCH_WIDTH = "1.875rem";
export const DEFAULT_COLOR_SWATCH_PADDING = "0.375rem";

export const getSwatchWidthInPx = (size: ColorSwatchProps["size"]): number => {
  const calculateWidth = (width: string, padding: string): number => {
    let pxToRemRatio = 16;
    if (window && document)
      pxToRemRatio = parseFloat(
        window.getComputedStyle(document.documentElement).fontSize
      );
    const DOUBLE_PADDING = 2;
    return (
      (parseFloat(width) + parseFloat(padding) * DOUBLE_PADDING) * pxToRemRatio
    );
  };

  if (size === "small")
    return calculateWidth(SMALL_COLOR_SWATCH_WIDTH, SMALL_COLOR_SWATCH_PADDING);

  return calculateWidth(
    DEFAULT_COLOR_SWATCH_WIDTH,
    DEFAULT_COLOR_SWATCH_PADDING
  );
};

export const SwatchContainer = styled.div<
  {
    theme: Theme;
    isSquare: boolean;
    invert: boolean | undefined;
    showUnderline: boolean;
  } & Required<Pick<ColorSwatchProps, "showColorName" | "size" | "selected">>
>(({size, selected, theme, isSquare, invert, showUnderline}) => {
  const height =
    size === "small" ? SMALL_COLOR_SWATCH_WIDTH : DEFAULT_COLOR_SWATCH_WIDTH;
  const width = height;
  const stylePath = invert
    ? outline(theme).brPdpCatRedesign.invert
    : outline(theme).brPdpCatRedesign;

  const outlineStyles =
    selected && !showUnderline ? stylePath.selected : stylePath.default;
  const border = isSquare
    ? {border: `${outlineStyles.outer.size} solid ${outlineStyles.outer.color}`}
    : {};
  const padding = isSquare ? {padding: `${outlineStyles.inner.size}`} : {};
  return {
    display: "inline-block",
    position: "relative",
    height,
    width,
    textAlign: "center",
    verticalAlign: "top",
    whiteSpace: "inherit",
    ...padding,
    ".focus-visible + img, .focus-visible + div": {
      outline: 0,
      zIndex: -1,
    },
    ...border,
  };
});
